import * as React from "react";
import {useState} from "react";

import {Input}    from "../input";

import "./fiveColumnMultiField.scss";


export const FiveColumnMultiField = ({specField, fullData}) => {

    const maxLengths = {
        columnOne: 30,
        columnTwo: 15,
        columnThree: 13,
        columnFour: 11,
        columnFive: 11
    }

    const columnOneField = fullData.find( field => field.fieldKey === specField.columnOneField);
    const columnTwoField = fullData.find( field => field.fieldKey === specField.columnTwoField);
    const columnThreeField = fullData.find( field => field.fieldKey === specField.columnThreeField);
    const columnFourField = fullData.find( field => field.fieldKey === specField.columnFourField);
    const columnFiveField = fullData.find( field => field.fieldKey === specField.columnFiveField);

    const [columnFieldValues, setColumnFieldValues] = useState({
        columnOne: columnOneField ? columnOneField.data : null,
        columnTwo: columnTwoField ? columnTwoField.data : null,
        columnThree: columnThreeField ? columnThreeField.data : null,
        columnFour: columnFourField ? columnFourField.data : null,
        columnFive: columnFiveField ? columnFiveField.data : null,
    });

    // update state to handle change of visible input fields & set value of original linked field that has been hidden
    function changeHandler (event) {
        const newValName = event.target.name;
        const newVal = event.target.value;
        const fieldName = event.target.getAttribute("data-fieldname");
        if (newVal.length > maxLengths[newValName]) return;
        setColumnFieldValues(prevValues => ({
            ...prevValues,
            [newValName]: newVal
        }));
        fullData.find( field => field.fieldKey === fieldName).onChange(newVal);
    }

    return (
        <div className="five-column-multi-field-23t">
            {specField.idDisplayStyle === 23 ? <div className="multi-field-label">{specField.displayLabel}</div> : null}
            <div className={specField.ordinal === 10 || specField.ordinal === 0  ? "multi-column-field first-or-last-row" : "multi-column-field"}>
                <div className="large-fields-container">
                    <Input
                        inputField
                        inputFieldName={"columnOne"}
                        inputType="text"
                        dataFieldName={specField.columnOneField}
                        fieldValue={columnFieldValues.columnOne}
                        className="column-input-lg"
                        changeHandler={(event) => changeHandler(event)}
                        extraInfo={{ "data-ignoreSave": "true" }}
                    />
                    <Input
                        inputField
                        inputFieldName={"columnTwo"}
                        inputType="text"
                        dataFieldName={specField.columnTwoField}
                        fieldValue={columnFieldValues.columnTwo}
                        className="column-input-lg"
                        changeHandler={(event) => changeHandler(event)}
                        extraInfo={{ "data-ignoreSave": "true" }}
                    />
                </div>
                <div className="small-fields-container">
                    <Input
                        inputField
                        inputFieldName={"columnThree"}
                        inputType="text"
                        dataFieldName={specField.columnThreeField}
                        fieldValue={columnFieldValues.columnThree}
                        className="column-input-sm"
                        changeHandler={(event) => changeHandler(event)}
                        extraInfo={{ "data-ignoreSave": "true" }}
                    />
                    <Input
                        inputField
                        inputFieldName={"columnFour"}
                        inputType="text"
                        dataFieldName={specField.columnFourField}
                        fieldValue={columnFieldValues.columnFour}
                        className="column-input-sm"
                        changeHandler={(event) => changeHandler(event)}
                        extraInfo={{ "data-ignoreSave": "true" }}
                    />
                    <Input
                        inputField
                        inputFieldName={"columnFive"}
                        inputType="text"
                        dataFieldName={specField.columnFiveField}
                        fieldValue={columnFieldValues.columnFive}
                        className="column-input-sm"
                        changeHandler={(event) => changeHandler(event)}
                        extraInfo={{ "data-ignoreSave": "true" }}
                />
                </div>
            </div>
        </div>
    )
}